import Typography from "@mui/material/Typography/Typography"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { useCurrentUserStore } from "@/stores/currentUserStore"

export const DashboardWelcome: FC = () => {
  const currentUser = useCurrentUserStore((state) => state.currentUser)

  return (
    <InformationMissingAlert icon={<InfoOutlined />}>
      <Typography variant='subtitle1'>Welcome to Aeros, {currentUser?.name}!</Typography>
      <Typography variant='body2'>Your personal Dashboard has not been configured yet!</Typography>
    </InformationMissingAlert>
  )
}
